import { LOCAL_STORAGE_KNOWN_KEYS } from '../../config/_const';
import ReduxRootState from '../../model/Redux/ReduxRootSate';
import ReduxActionInterface from '../../model/ReduxActionInterface';
import * as ThemeAction from './actionsType';

const ROOT_VALUE_STATE: ReduxRootState = {
    loading: false,
    data: localStorage.getItem(LOCAL_STORAGE_KNOWN_KEYS.TDX_THEME) || 'light',
};

export const themeReducer = (state: ReduxRootState = ROOT_VALUE_STATE, action: ReduxActionInterface) => {

    switch (action.type) {
        case ThemeAction.SWITCH_THEME:
            localStorage.setItem(LOCAL_STORAGE_KNOWN_KEYS.TDX_THEME, state.data === 'light' ? 'dark' : 'light');
            return {
                ...state,
                data: state.data === 'light' ? 'dark' : 'light',
            };

        default: return state;
    }
};
